<template>
  <a target="_blank" rel="noopener noreferrer" :href="url" class="suggestion">{{
    title
  }}</a>
</template>

<style lang="sass" scoped>
.suggestion
    display: inline-block
    padding: 8px 12px
    border-radius: 40px
    border: 1px solid #DADCE0
    color: #202124
    cursor: pointer
    margin-right: 5px
    font-weight: 500
    margin-bottom: 12px

.suggestion[href]
    background: #ffffff
    color: #202124
    text-decoration: none
</style>

<script>
export default {
  name: "Suggestion",
  props: ["title", "url"]
};
</script>
